// extracted by mini-css-extract-plugin
module.exports = {"appContainerCartOpen":"nAbPlaSL KpZ75hDB _2NpQaAbf _6zYUaDCs _1o8WwOAn _3KUd9j14","appContainer":"_2lMTCO7K","appContainerScrollingDown":"oVUkQG3g"};